"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamTypingIndicator = void 0;
var _react = _interopRequireDefault(require("react"));
var _streamChatReact = require("stream-chat-react");
require("./TeamTypingIndicator.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TeamTypingIndicator = function TeamTypingIndicator(props) {
  var type = props.type;
  var _useChatContext = (0, _streamChatReact.useChatContext)(),
    client = _useChatContext.client;
  var _useTypingContext = (0, _streamChatReact.useTypingContext)(),
    typing = _useTypingContext.typing;
  if (!client || !typing) {
    return null;
  }
  if (type === 'list') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "typing-indicator__list"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "dots"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "dot"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "dot"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "dot"
    })));
  }
  var users = Object.values(typing).filter(function (_ref) {
    var _client$user;
    var user = _ref.user;
    return (user === null || user === void 0 ? void 0 : user.id) !== ((_client$user = client.user) === null || _client$user === void 0 ? void 0 : _client$user.id);
  }).map(function (_ref2) {
    var user = _ref2.user;
    return user.name || user.id;
  });
  if (!users.length) {
    return null;
  }
  var text = 'Someone is typing';
  if (users.length === 1) {
    text = "".concat(users[0], " is typing");
  } else if (users.length === 2) {
    text = "".concat(users[0], " and ").concat(users[1], " are typing");
  } else if (users.length > 2) {
    text = "".concat(users[0], " and ").concat(users.length - 1, " more are typing");
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "typing-indicator__input"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dots"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dot"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "dot"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "dot"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "typing-indicator__input__text"
  }, text));
};
exports.TeamTypingIndicator = TeamTypingIndicator;